import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail } from "lucide-react";

export const StickyEnquiry = () => {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;
  return (
    <Link
      to="/contact"
      data-testid="sticky-enquiry-button"
      className="lg:hidden fixed bottom-4 right-4 z-30 inline-flex items-center gap-2 rounded-full bg-orange-600 px-5 py-3.5 text-white font-semibold shadow-lg shadow-orange-600/30 hover:bg-orange-700 transition-colors"
    >
      <Mail className="h-5 w-5" aria-hidden="true" />
      Make an enquiry
    </Link>
  );
};
